import { PhotoAttribution, type PhotoAttributionData } from './PhotoAttribution';

interface ZoomLevel {
  level: number;
  imageUrl: string;
}

interface ZoomImageProps {
  levels: ZoomLevel[];
  activeLevel: number;
  attribution?: PhotoAttributionData | null;
}

export function ZoomImage({ levels, activeLevel, attribution }: ZoomImageProps) {
  if (!levels.length) return <div className="zoom-frame" />;

  return (
    <div className="zoom-frame">
      {levels.map((z) => (
        <img
          key={z.level}
          src={z.imageUrl}
          alt={z.level === activeLevel ? 'Énigme — portion zoomée' : ''}
          className={`zoom-image${z.level === activeLevel ? ' is-active' : ''}`}
          draggable={false}
          loading="eager"
          decoding="async"
        />
      ))}
      <PhotoAttribution attribution={attribution} />
    </div>
  );
}
